import React, { useState } from "react";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logoImage from "../../assests/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { authServices } from "../../services/authServices";
import AlertComponent from "../alert/alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Login() {
  let [credential, setCredential] = useState({ username: "", password: "" });
  let [isPassword, setIsPassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  let navigate = useNavigate();

  const onInputChange = (e) => {
    let { name, value } = e.target;
    setCredential({ ...credential, [name]: value });
  };

  const passwordViewChange = () => {
    setIsPassword(!isPassword);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onLoginSubmit();
    }
  };

  const onLoginSubmit = () => {
    if (credential.username === "") {
      setAlertComponent({
        open: true,
        type: "error",
        message: "	Please enter an UserName.",
      });
    } else if (credential.password === "") {
      setAlertComponent({
        open: true,
        type: "error",
        message: "Please enter a password.",
      });
    } else {
      setIsLoading(true);
      authServices
        .loginAuth({
          type: "userName",
          userInfo: credential?.username,
          password: credential?.password,
        })
        .then(function (response) {
          if (response?.data?.success == true) {
            sessionStorage.setItem(
              "user",
              JSON.stringify(response?.data?.data)
            );
            if (response?.data?.data?.role.name == "VENDOR") {
              window.location.href = "/admin/welcome";
            } else {
              window.location.href = "/admin/dashboard";
            }
            // let path = `/admin/dashboard`;
            // navigate(path);
          }
        })
        .catch(function (error) {
          setAlertComponent({
            open: true,
            type: "error",
            message: `${error?.response?.data?.message}`,
          });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="login-form">
      <div className="text-center">
        <div className="logo_login_react_vendors">
          <img src={logoImage} alt="" height="51" />
        </div>
        <h3 className="title">Login to your Account</h3>
        <p>See what is going on with your business</p>
      </div>
      <div className="mb-4 position-relative">
        <label className="mb-1 text-dark">Username</label>
        <input
          type="Username"
          name="username"
          className="form-control form-h"
          onChange={onInputChange}
          value={credential?.username}
          placeholder="Enter your username"
          onKeyPress={onKeyPressHandler}
        />

        <span className="user">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-person"
            viewBox="0 0 16 16"
          >
            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
          </svg>
        </span>
      </div>
      <div className="mb-4 position-relative">
        <label className="mb-1 text-dark">Password</label>
        <input
          type={isPassword == true ? "password" : "text"}
          name="password"
          className="form-control form-h"
          onChange={onInputChange}
          value={credential?.password}
          placeholder="Enter your password"
          onKeyPress={onKeyPressHandler}
        />

        <span className="lock">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            fill="currentColor"
            className="bi bi-lock"
            viewBox="0 0 16 16"
          >
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
          </svg>
        </span>

        <span className="show-pass eye" onClick={passwordViewChange}>
          {isPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}

          {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-eye-slash"
              viewBox="0 0 16 16"
            >
              <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
              <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
            </svg> */}
        </span>
      </div>
      <div className="form-row d-flex justify-content-between mt-4 mb-2">
        <div className="mb-4">
          <div className="form-check custom-checkbox mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="customCheckBox1"
            />
            <label className="form-check-label remember_me">Remember Me</label>
          </div>
        </div>
        <div className="mb-4">
          <Link
            to="/auth/forgot-password"
            className="btn-link text-primary for_pass"
          >
            Forgot Password?{" "}
          </Link>
        </div>
      </div>
      <div className="text-center mb-4">
        <button
          onClick={onLoginSubmit}
          className="btn btn-primary btn-log login-btn"
        >
          Login{" "}
        </button>
      </div>
      <h6 className="login-title">
        <span> OR </span>
      </h6>

      <div className="mb-3 d-flex">
        <Link to="/auth/mobile-auth" className="btn otp flex-fill">
          Login with OTP{" "}
        </Link>
        <Link to="/auth/email-login" className="btn otp flex-fill">
          Login with Email{" "}
        </Link>
        {/* <a href="email" className="btn otp flex-fill">
          Login with Email
        </a> */}
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default Login;
